import React, { memo } from 'react';

const CircledArrowRight = memo(({ size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7969 22C18.3197 22 22.7969 17.5228 22.7969 12C22.7969 6.47715 18.3197 2 12.7969 2C7.27403 2 2.79688 6.47715 2.79688 12C2.79688 17.5228 7.27403 22 12.7969 22Z"
        stroke="#D3D3D3"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M13.3262 8.65974L16.6878 12.0214"
        stroke="#D3D3D3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3369 15.4362L16.6985 12.0746"
        stroke="#D3D3D3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.9043 12.0423H16.5183"
        stroke="#D3D3D3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

export default CircledArrowRight;
